import { Trans } from '@lingui/react/macro'
import { StakeAccount } from '../../api/types'
import { UnstakeCard } from './UnstakeCard'
import { UnstakeEmptyState } from './UnstakeEmptyState'

export type { StakeAccount }

type UnstakeFormProps = {
  stakeAccounts: StakeAccount[]
  isLoading: boolean
  onSuccess: () => void
}

export const UnstakeForm = ({ stakeAccounts, onSuccess, isLoading }: UnstakeFormProps) => {
  return (
    <div className="flex grow flex-col">
      <div className="mb-6 flex flex-col gap-2">
        <div className="text-gray-70 font-semibold">
          <Trans>Unstaking requires two key steps.</Trans>
        </div>
        <div className="text-gray-90 text-body-2">
          <Trans>
            Unstake initiates the unstaking process and takes approximately three (3) days. After this your SOL will be
            available for withdrawal.
          </Trans>
        </div>
      </div>
      {stakeAccounts.length === 0 ? (
        <UnstakeEmptyState isLoading={isLoading} />
      ) : (
        <div className="space-y-4">
          {stakeAccounts.map((account) => (
            <UnstakeCard key={account.pubkey.toBase58()} account={account} onSuccess={onSuccess} />
          ))}
        </div>
      )}
    </div>
  )
}
